import { defineMessages } from '@transcend-io/internationalization';

export const dataPreviewBlockMessages = defineMessages(
  'pc-core-components.DataPreviewBlock.dataPreviewBlock',
  {
    fileTooLarge: {
      defaultMessage:
        'File is too large to display. To redact this file you can download and re-upload it manually.',
    },
  },
);
